module.exports = __webpack_public_path__ + "64c7c54b7b2422fed6b5c967f0e2201b.svg";